import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { applicationDocumentLoader } from './applicationDocumentLoader'

const schema = z.object({
  historyPage: z.number().optional(),
  historySize: z.number().optional()
})

export const DocumentDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$applicationId/document/$documentId',
    component: lazyRouteComponent(() => import('./ApplicationDocument')),
    loader: applicationDocumentLoader,
    validateSearch: (search) => schema.parse(search),
    loaderDeps: ({ search: { historyPage, historySize } }) => ({ historyPage, historySize }),
    gcTime: 0
  })
